import { Message } from "../../../domain/model/Auth";
import { Category } from "../../../domain/model/Category";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { CategoryRepository } from "./CategoryRepository";

export class CategoryRepositoryImpl implements CategoryRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  createCategory(category: Category): Promise<Response<Message>> {
    return this.apiService.createCategory(category);
  }
  getCategories(): Promise<Response<Array<Category>>> {
    return this.apiService.getCategories();
  }
  getCategory(id: string): Promise<Response<Category>> {
    return this.apiService.getCategory(id);
  }
  updateCategory(category: Category): Promise<Response<Message>> {
    return this.apiService.updateCategory(category);
  }
  deleteCategory(id: string): Promise<Response<Message>> {
    return this.apiService.deleteCategory(id);
  }
}
